import { localeReducer } from './locale';
import { screenReducer } from './screen';
import { userReducer } from './user';
import type {
  CoBrandDetailsAction,
  ClaimDetailsAction,
  GlobalContextAction,
  GlobalContextReducerState,
  LocaleAction,
  RBACPermissionsAction,
  RBACRedirectConfigAction,
  ScreenAction,
  ToastAction,
  UserAction,
  VerifierAuthenticationAction,
  ActiveFeatureConfigAction
} from './types';
import { toastReducer } from './toast';
import { permissionReducer } from './permission';
import { routeConfigReducer } from './routeConfig';
import { verifierAuthenticationReducer } from './verifierAuthentication';
import { claimDetailsReducer } from './claimDetails';
import { coBrandDetailsReducer } from './CoBrandDetails';
import { activeFeatureConfigReducer } from './activeFeatureConfig';
import { Portal } from '@dfg/brahma-types';

export const rootReducer = (
  {
    screen,
    locale,
    user,
    toast,
    permissions,
    routeConfig,
    verifierAuthenticationDetails,
    claimDetails,
    coBrandDetails,
    activeFeatureConfig
  }: GlobalContextReducerState,
  action: GlobalContextAction
): GlobalContextReducerState => ({
  screen: screenReducer(screen, action as ScreenAction),
  locale: localeReducer(locale, action as LocaleAction),
  user: userReducer(user, action as UserAction),
  toast: toastReducer(toast, action as ToastAction),
  permissions: permissionReducer(permissions, action as RBACPermissionsAction),
  routeConfig: routeConfigReducer(
    routeConfig,
    action as RBACRedirectConfigAction
  ),
  verifierAuthenticationDetails: verifierAuthenticationReducer(
    verifierAuthenticationDetails,
    action as VerifierAuthenticationAction
  ),
  claimDetails: claimDetailsReducer(claimDetails, action as ClaimDetailsAction),
  coBrandDetails: coBrandDetailsReducer(
    coBrandDetails,
    action as CoBrandDetailsAction
  ),
  activeFeatureConfig: activeFeatureConfigReducer(
    activeFeatureConfig,
    action as ActiveFeatureConfigAction
  ),
  portal: Portal.IA
});
